.form {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: var(--depth1);
	border-radius: var(--roundedBig);
	position: relative;
}

/* @media screen and (max-width: 900px) {
	.form {
		width: 90%;
		position: relative;
	}
	.form > label > input {
		width: 100% !important;
	}
} */

.form > h1 {
	font-size: 1.75rem;
	color: var(--primary);
}
